import { toast, ToastContainer } from "react-toastify";
import Footer from "../components/footer";
import Header from "../components/header";
import RequestModal from "../components/RequestModal";
import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import ReadMoreParagraph from "../../admin/components/ReadMoreParagraph";
import LoaderHomePd from "../components/loaderHomePd";
import DataTable from "react-data-table-component";
import { useNavigate , useLocation} from "react-router-dom";
import { CartContext } from "../../../contexts/cartContext";
import { CurrencyContext } from "../../../contexts/currencyContext";
import debounce from "lodash.debounce";


// Helper function to get wishlist from localStorage
const getWishlistFromLocalStorage = () => {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
};

const ArtworkViewAll = () => {

    const location = useLocation();
    const { artworkType } = location.state || {};

    const [artworkList, setArtworkList] = useState([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [wishlists, setWishlists] = useState([]);
    const { wishlist, addToWishlist } = useContext(CartContext);

    // State for dropdown Orientation 
    const [size, setSizes] = useState([]);
    const [selectedSize, setSelectedSize] = useState(0);

    // State for dropdown Price nRange 
    const [priceRange, setPriceRanges] = useState([]);
    const [selectedPriceRange, setSelectedPriceRange] = useState(0);

    // State for dropdown Sorting 
    const [sorting, setSorting] = useState([]);
    const [selectedSorting, setSelectedSorting] = useState(0);
    const [artworkTitle, setArtworkTitle] = useState('');
    const [artworkContent, setArtworkContent] = useState('');

    
    const getArtworkContent = async () => {
        debugger;
        try {
            const response = await axios.get(`https://igapi.heuristticminds.com/api/UserInterface/Get-GetArtworkContentByTypeId?typeId=${artworkType}`);
            if (response.data) {
                setArtworkTitle(response.data.detailTitle);   // Set title
                setArtworkContent(response.data.detailContent);   // Set content
            }
        } catch (error) {
            console.log('Error fetching artwork content:', error);
        }
    };

    const getArtworkAll = async () => {

        try {
            setLoading(true);
            const delay = new Promise(resolve => setTimeout(resolve, 500)); // 500 ms delay
            await delay;

            const response = await axios.get(`https://igapi.heuristticminds.com/api/UserInterface/Get-GetArtworkDetailsForViewAll?type=${artworkType}`)
            setArtworkList(response.data);
        }
        catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const columns = [
        {
            cell: (row) => {
                const isInWishlist = wishlists.some(item => item.product_id === row.product_id);
                return (
                    <div className="pd_item" key={row.product_id}>
                        <div className="img_box">
                            <img src={`../../../images/products/thumbnail/${row.image}`} className="pd_img" alt="" />
                            <a href="#" className="wishlist_link" title="WISHLIST" onClick={(e) => {
                                e.preventDefault();
                                handleWishlistClick(row); // Updated function
                               
                            }}>
                                <i className={`${isInWishlist ? 'bi bi-suit-heart-fill text-danger' : 'bi bi-suit-heart'}`}></i>
                            </a>
                            <span className="q_view" onClick={() => handleDetails(row.product_id, row.productTitle)}>
                                <i className="bi bi-eye"></i> Quick View
                            </span>
                            <span className="size">Size: <b>{row.size}</b></span>
                        </div>
                        <div className="pd_content">
                            <span className="pd_brand">{row.productTitle}</span>
                            <span className="pd_title">{row.category}: {row.categoryType}</span>
                            <span className="pd_title">Art by:
                                <span className="btn_artist1" onClick={() => handleArtist(row.artist_id, row.artistName)}>
                                    {row.artistName}
                                </span>
                            </span>
                            {
                                row.price_on_demand === 1 ? <><span className="btn_req" onClick={() => handleRequestPrice(row.product_id, row.productTitle)}>Request Price</span></> :

                                    <div className="Price">
                                        {currencyContxt.icon} {(row.price / currencyContxt.value).toFixed(2)}
                                        {
                                            row.discountRate === 0 ? ''
                                                : <>
                                                    <span className="old_price">{currencyContxt.icon} {(row.gstMRP / currencyContxt.value).toFixed(2)}</span><span className="discount">({row.discountRate}%)</span>
                                                </>
                                        }
                                        {
                                            currencyContxt.currency == "INR" ?
                                                <small>Including GST</small>
                                                :
                                                <></>
                                        }
                                    </div>
                            }

                        </div>
                    </div>
                );
            }
        },
    ];

    const paginationComponentOptions = {
        noRowsPerPage: true
    };

    useEffect(() => {
        getArtworkAll();
        getArtworkContent();
    }, []);

    //const introText = `So if you are here, you have made the correct choice of preferring <b>IndiGalleria</b> to buy ${artworkList[0]?.category} from emerging, experienced and renowned Indian artists. We have a collection of <b>${artworkList.length}</b> Original ${artworkList[0]?.category} For Sale which will give you an impeccable shopping experience for home decor, hotels and corporate or investment purposes not forgetting paintings as a token of gift to your loved ones to make them feel the delicacy of owning a ${artworkList[0]?.category}. Think maybe twice, but not thrice, about where to buy original handmade artworks online, go for IndiGalleria. We sell absolutely original and authentic artworks. To know what is original artwork and Reasons to buy it do visit our blog! `;
    const TextAboutGalleria = `<b>IndiGalleria</b> is one of the best online art galleries having an enormous collection of original paintings, whether it is acrylic, oil, watercolour, mixed media or charcoal, or any painting to be made on your special demand, your wishes will not be left unfulfilled. Even if you are looking for Abstract, Figurative, Contemporary, Indian Folk Art like Madhubani or Figurative Paintings depicting Indian culture you will get to choose from a lot of masterpiece collections. Landscape or seascape paintings are also available in hyper-realistic, realistic and abstract forms. If you wish to buy mythological paintings like Buddha, Ganesha, Radha-Krishna etc you will get a different style of artwork in one place. We have also extended our reach to provide you paintings of animals which includes horses, bulls, cows, monkeys, dogs and fish paintings at the best price. IndiGalleria is committed to providing art lovers to buy original authentic paintings online. Write us at info@indigalleria.com in case of a bulk order of original artworks. `;

    const handleDetails = (id, productTitle) => {
        const formattedTitle = productTitle.replace(/ /g, '-'); // Replace spaces with '-'
        navigate(`/artwork/${formattedTitle}-${id}`, { state: { id: id}});
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    };

    const handleArtist = (artistId, artistName) => {
        const artist = artistName.replace(/ /g, '-'); // Replace spaces with '-'
        navigate(`/artist/${artist}-${artistId}`, { state: { artistId: artistId}});
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    };

    //Wishlist Click
    const userInfo = JSON.parse(localStorage.getItem('user-info'));
    // Fetch the wishlist data when the page loads
    const fetchWishlistData = async () => {
                
        if (userInfo && userInfo.buyer_id) {
            try {
                const response = await fetch(`https://igapi.heuristticminds.com/api/WishList/Get-GetWishListByUserID?user_id=${userInfo.buyer_id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const wishlistData = await response.json();

                if (wishlistData && Array.isArray(wishlistData)) {
                    setWishlists(wishlistData); // Store complete wishlist items from API
                } else {
                    setWishlists([]); // Set an empty wishlist if no data is returned
                }

            } catch (error) {
                console.error('Error fetching wishlist:', error);
            }
        } else {
            const localWishlist = getWishlistFromLocalStorage();
            setWishlists(localWishlist); // Store complete wishlist items from local storage
        }
    };

    // Handler for Wishlist Button Click
    const handleWishlistClick = async(item) => {
        debugger;
        const itemIsInWishlist = isInWishlist(item.product_id);

        if (userInfo && userInfo.buyer_id) {

            try {
                const payload = {
                    customer_id: userInfo.buyer_id,
                    product_id: item.product_id,
                };
                    const response = await fetch("https://igapi.heuristticminds.com/api/WishList/Add-SaveWishList", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });
                    
                if (!response.ok) {
                    throw new Error(`Failed to update wishlist: ${response.statusText}`);
                }
    
                // Extract JSON data from the response
                const { action } = await response.json(); // Destructuring to get action flag
    
    
                // Display success message based on the action performed
                if (action === "Add") {
                    toast.success("Artwork Added to Wishlist !!");
                } else if (action === "Remove") {
                    toast.error("Artwork Removed from Wishlist !!");
                }
                    // Fetch the updated wishlist after modification
                    await fetchWishlistData();  // Refresh state with the updated wishlist from the database
            } catch (error) {
                console.error("Error syncing wishlist item:", item.product_id, error);
            }
        }
        else{
            if (itemIsInWishlist) {
                // Remove from wishlist logic
                removeFromWishlist(item.product_id);
                toast.error("Artwork Removed from Wishlist 2 !!");
            } else {
                addToWishlist(item);
                toast.success("Artwork Added to Wishlist !!");
            }
        }
        

        handleWishlistUpdate(); // Refresh wishlist state after adding/removing
    };

    // Helper function to get wishlist from localStorage
    const getWishlistFromLocalStorage = () => {
        return JSON.parse(localStorage.getItem('wishlist')) || [];
    };

    // Context or state management function
    const handleWishlistUpdate = () => {
        
        if (userInfo && userInfo.buyer_id) {
            fetchWishlistData(); // Fetch from API
        } else {
            const updatedWishlist = getWishlistFromLocalStorage(); // Fetch from local storage
            setWishlists(updatedWishlist); // Update state
        }        
    };
    const isInWishlist = (productId) => {
        return wishlists.some(item => item.product_id === productId);
    };

    // Function to remove item from the wishlist
    const removeFromWishlist = (productId) => {
        const updatedWishlist = wishlists.filter(item => item.product_id !== productId);
        setWishlists(updatedWishlist); // Update state
        localStorage.setItem('wishlist', JSON.stringify(updatedWishlist)); // Update local storage
    };

    useEffect(() => {
        const loadWishlist = async () => {
            await fetchWishlistData();
        };
        loadWishlist();
    }, []);
    useEffect(() => {
        setWishlists(wishlist);
    }, [wishlist]); // This will trigger every time the wishlist state changes


    //WishList Click ends


    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedPd, setSelectedPd] = useState(null);

    const handleRequestPrice = (id, pdTitle) => {
        setModalOpen(true);
        setSelectedId(id);
        setSelectedPd(pdTitle);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedId(null);
        setSelectedPd(null);
    };
    const { currencyContxt } = useContext(CurrencyContext); // Use context

    

    // Fetch wishlist from localStorage when component mounts
    useEffect(() => {
        const savedWishlist = getWishlistFromLocalStorage();
        setWishlists(savedWishlist);
    }, []);

    useEffect(() => {
        handleDropdownChange();
    }, [selectedSize, selectedPriceRange, selectedSorting]);

    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-SizeList', setSizes);        
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-PriceRangeList', setPriceRanges);
    }, [artworkType]);

    const handleDropdownChange = debounce(async () => {

        const url = `https://igapi.heuristticminds.com/api/UserInterface/Get-GetArtworkDetailsForAllByFilter?type=${artworkType}&size_id=${selectedSize}&priceRange_id=${selectedPriceRange}&sort_id=${selectedSorting}`;

        try {
            const response = await axios.get(url);
            setArtworkList(response.data);
        } catch (error) {
            console.log(error);
        }
    }, 500);
    
    const handleGenericChange = ({ target: { name, value } }) => {
        const selectedValue = parseInt(value, 10);
    
        switch (name) {
            case 'size':
                setSelectedSize(selectedValue);
                break;
            case 'priceRange':
                setSelectedPriceRange(selectedValue);
                break;
            case 'sorting':
                setSelectedSorting(selectedValue);
                break;
            default:
                break;
        }
        
        handleDropdownChange();
    };
    
    const handleClearFilters = () => {
        setSelectedSize(0);
        setSelectedPriceRange(0);
        setSelectedSorting(0);
        handleDropdownChange();  // Refresh with cleared filters
    };

    const handleViewAllArtworks = () => {

        setSelectedSize(0);
        setSelectedPriceRange(0);
        setSelectedSorting(0);
        getArtworkAll();   
    
    };


    return (
        <>
            <Header />
            <div style={{ marginTop: '150px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <h2 className="sec_title">{artworkTitle ||  'ARTWORKS'}</h2>
                        
                            <span className="details" dangerouslySetInnerHTML={{ __html: artworkContent }} />
                        </div>
                        <div className="row">
                            <div className="col-md-6 filter_list">
                                <div className="row">
                                    <div className="col-sm p-1">
                                        <select name="size" value={selectedSize} onChange={handleGenericChange} className="form-select">
                                            <option value={0}>-Size-</option>
                                            {size.map((sizeName) => (
                                                <option key={sizeName.id} value={sizeName.id}>
                                                    {sizeName.size}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-sm p-1">
                                        <select name="priceRange" value={selectedPriceRange} onChange={handleGenericChange} className="form-select">
                                            <option value={0}>-Price Range-</option>
                                            {priceRange.map((range) => (
                                                <option key={range.id} value={range.id}>
                                                    {range.priceRange}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-sm p-1">
                                        <select name="sorting" value={selectedSorting} onChange={handleGenericChange} className="form-select">
                                            <option value={0}>-Sort-</option>
                                            <option value={1}>Price : Low to High</option>
                                            <option value={2}>Price : High to Low</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 text-end pe-0">
                                <button className="btn_req me-2" onClick={handleClearFilters}>Clear All</button>
                                <button className="btn_req" onClick={handleViewAllArtworks}>View All Artworks</button>
                            </div>
                        </div>

                        <div className="col-md-12 pd-list">
                            {
                                loading ? (<LoaderHomePd />
                                ) : (
                                    <DataTable
                                        columns={columns}
                                        data={artworkList}
                                        pagination
                                        noTableHead
                                        paginationComponentOptions={paginationComponentOptions}
                                        paginationPerPage={[20]}
                                    />
                                )}
                        </div>

                        <div className="col-sm-12 mb-5">
                            <h2 className="sec_title">About IndiGalleria</h2>
                            <ReadMoreParagraph text={TextAboutGalleria} maxLength={380} />
                        </div>
                    </div>

                </div>
            </div>
            <ToastContainer position="bottom-right" />
            <RequestModal isOpen={isModalOpen} onClose={handleCloseModal} id={selectedId} pdTitle={selectedPd} />
            <Footer />
        </>
    )
};

export default ArtworkViewAll;